import { render, staticRenderFns } from "./PreviewVideos.vue?vue&type=template&id=1280d69b&scoped=true&"
import script from "./PreviewVideos.vue?vue&type=script&lang=js&"
export * from "./PreviewVideos.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideos.vue?vue&type=style&index=0&id=1280d69b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280d69b",
  null
  
)

export default component.exports